import { render } from "./ContactView.vue?vue&type=template&id=6f4c9a2c&scoped=true"
import script from "./ContactView.vue?vue&type=script&lang=js"
export * from "./ContactView.vue?vue&type=script&lang=js"

import "./ContactView.vue?vue&type=style&index=0&id=6f4c9a2c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4c9a2c"]])

export default __exports__